import styled from 'styled-components'
import { colors } from '../../../const/theme'
import { Card, Modal } from '../../../components'
import { Span } from '../../../typography'

export const BootstrapModal = styled(Modal)`
  display: flex !important;

  .modal-content {
    height: 100%;
  }
`

export const CardWrapper = styled(Card)`
  width: 45%;
  padding: 0 32px 16px;
  @media (max-width: 415px) {
    width: 100%;
    margin-bottom: 16px;
  }
`
export const CourseSelectionWrapper = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  height: 88px;
  margin-bottom: 0;

  @media (max-width: 415px) {
    width: 100%;
    margin: 8px 0 12px 0;
  }
`

export const CourseSelect = styled.div`
  height: 40px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 5px;
  line-height: 40px;
  padding: 0 12px;
  &:hover,
  &:focus {
    border-color: ${({ theme: { input } }) => input.focus};
    cursor: pointer;
  }
`

export const CourseCheckBoxWrapper = styled.div`
  padding: 0 12px;
  line-height: 50px;
  height: 50px;
  width: 100%;
  display: flex;

  .react-datepicker-wrapper {
    margin-top: -24px;
    margin-left: 24px;
  }
  #course-name {
    min-width: 70px;
  }
`

export const SelectCheckBox = styled.div`
  height: 40px;
  display: flex;
  margin: auto 0;
`

export const CheckBoxContainer = styled.div`
  overflow: scroll;
`

export const CourseName = styled(Span)`
  width: 100%;
`
export const DatePickerWrapper = styled.div`
  margin: 0 12px 12px;
  width: 30%;
`
